import { Box, Flex } from "@chakra-ui/react";
import { BrandedLogo } from "@root/components/branding";
import { CollapseIcon } from "@root/assets/icons/collapseicon";
import SidebarHeaderIcon from "@root/assets/sidebarheadericon";
import { useGlobalContext } from "@root/context/global-context";
import { LogoCollapseIcon } from "@root/assets/icons/logoCollapse";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";

export function SidebarHeader({ lg, isOpen, isDarkTheme, onNavigate }: any) {
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen((prev: any) => !prev);
  };

  const handleLogoClick = () => {
    if (onNavigate) {
      onNavigate();
    }
    navigate(ROUTE_NAMES.DASHBOARD);
  };

  return (
    <Flex
      gap="16px"
      justifyContent={isSidebarOpen ? "space-between" : "center"}
      alignItems="center"
      py={isSidebarOpen ? "5px" : "3px"}
      paddingLeft={isSidebarOpen ? "10px" : "8px"}
      paddingRight={isSidebarOpen ? "10px" : "8px"}
      flexDirection="row"
      bg="transparent"
    >
      {isSidebarOpen ? (
        <Box
          cursor="pointer"
          onClick={handleLogoClick}
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <BrandedLogo variant="full" />
        </Box>
      ) : (
        <Box
          cursor="pointer"
          onClick={handleLogoClick}
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <BrandedLogo variant="small" width={"35px"} height={"35px"} />
        </Box>
      )}
      {isSidebarOpen && (
        <Flex
          bg="transparent"
          cursor={"pointer"}
          onClick={toggleSidebar}
          alignItems="center"
          justifyContent="center"
          minWidth="24px"
          minHeight="24px"
        >
          <CollapseIcon width={15} height={15} />
        </Flex>
      )}
    </Flex>
  );
}
